export default "__VITE_ASSET__D0WYng_d__"